import { getWindow } from '@ps/web-core-utils';
import { CashierPath } from '@ps/web-pam-types';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import useWizardContext from '@swf/core/hooks/useWizardContext';
import { select } from '@swf/core/store';

import type { DepositPayload, DepositResult, RedirectContext } from '../../../../types/Cashier';
import {
  calculateCashBonusAmount,
  formatCardReference,
  getPaySystemName,
  getSavedMethod,
  sanitizeDeposit
} from '../../../../utils/cashier';

const useDepositServicesData = (): RedirectContext => {
  const {
    data: {
      depositResult,
      previousDeposit,
      deposit = {} as DepositPayload,
      cmsHeaderAndGridLayout,
      paySystems = [],
      savedCards = [],
      savedCardInfoId,
      preCashinInfo
    },
    values: { deposit: { accountNumber } = {} }
  } = useWizardContext();
  const { formatNumber } = useIntl();
  const locale = useSelector(select.locale.get);
  const pathname = useSelector(select.location.getPathname);
  const paySystemName = getPaySystemName(paySystems, deposit.type);
  const [savedMethod] = getSavedMethod(savedCards, savedCardInfoId);
  const maskedCardNum = savedMethod?.savedCard?.maskedCardNum || formatCardReference(accountNumber);
  const { status, transactionId, trhash, wc2Paycallback } = depositResult as DepositResult;

  const returnUrl = pathname.includes(`/${locale}/`)
    ? `/${locale}${CashierPath.DepositResult}`
    : `${CashierPath.DepositResult}`;

  return {
    transactionId,
    redirectStatus: status,
    deposit: sanitizeDeposit(deposit),
    previousDeposit: previousDeposit && sanitizeDeposit(previousDeposit),
    securityKey: trhash,
    theme: 'first-dark',
    returnUrl: `${wc2Paycallback || getWindow()?.location.origin + returnUrl}`,
    cmsHeaderAndGridLayout: !!cmsHeaderAndGridLayout,
    paySystemName,
    maskedCardNum,
    bonusAmount: preCashinInfo && calculateCashBonusAmount(preCashinInfo, formatNumber)
  };
};

export default useDepositServicesData;
